import type { IColumnDefinition } from '@/creditflowresearch/ui/common/components/DataTable/columns';
import {
  makeTextColumn,
  makeDateColumn,
  makeBooleanColumn,
  makeNumberColumn,
  makePercentColumn,
  makeMoneyColumn,
  makeDictionaryColumn,
  makeListColumn,
} from '@/creditflowresearch/ui/common/components/DataTable/columns';

const columnRenderStrategyMap: Record<string, (config: any) => IColumnDefinition> = {
  text: makeTextColumn,
  date: makeDateColumn,
  number: makeNumberColumn,
  percent: makePercentColumn,
  money: makeMoneyColumn,
  boolean: makeBooleanColumn,
  dictionary: makeDictionaryColumn,
  list: makeListColumn,
};

export default columnRenderStrategyMap;
